export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";